import { factory, getResponseCamelization } from '@repo-level/core-front';

import { buildCmsUrl, getResponseCMS } from './base';
import { isCMSV3 } from 'helpers/conf';

export interface CmsABTest {
  title: string;
  version?: string;
}

export const cmsABTestsV3 = factory((r) => () =>
  r<CmsABTest[]>('get', buildCmsUrl({ path: 'ab-tests' }))
);

export const cmsABTestsV4 = factory((r) => () =>
  r<CmsABTest[]>('get', buildCmsUrl({ path: 'ab-tests' }), undefined, {
    transformResponse: [getResponseCamelization(), getResponseCMS],
  })
);

export const cmsABTests = isCMSV3 ? cmsABTestsV3 : cmsABTestsV4;
